<template>
  <img :src="`./${iconpath}`" :alt="`${alttext}`" />
</template>
<script>
export default {
  name: 'file-icon',
  props: ['filename'],
  computed: {
    iconpath() {
      let parts = this.filename.split('.')
      let ext = parts[parts.length - 1]
      let iconfile;

      // console.log(ext)

      switch (ext) {
      case "docx":
      case "doc":
        iconfile = 'application-icons/word-icon24x24.png'
        break;
      case "xlsx":
      case "xls":
        iconfile = 'application-icons/xls-icon24x24.png'
        break;
      case "csv":
        iconfile = 'application-icons/csv-icon24x24.png'
        break;
      case "pdf":
        iconfile = 'application-icons/pdf-icon24x24.png'
        break;
      case "zip":
        iconfile = 'application-icons/zip-icon24x24.png'
        break;
      default:
        iconfile = 'application-icons/unknown-icon24x24.png'
      }

      return iconfile
    },
    alttext() {
      let _, ext = this.filename.split('.')
      let t;

      switch (ext) {
      case "docx":
      case "doc":
        t = 'Word Document'
        break;
      case "xlsx":
      case "xls":
        t = 'Excel Document'
        break;
      case "csv":
        t = 'CSV Document'
        break;
      case "pdf":
        t = 'PDF Document'
        break;
      case "zip":
        t = 'ZIP File'
        break;
      default:
        t = 'Other File'
      }
      return t
    },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>
<style lang="scss">
</style>
